<template>
  <transition name="el-zoom-in-top">
    <el-dialog title="工单录入明细" :visible.sync="show" width="65%" :modal-append-to-body='true'>
      <div style="text-align: left;">
        <el-card class="box-card" style="text-align: left" v-show="editshow">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="12">
                <h3>修改明细</h3>
              </el-col>
              <el-col :span="12">
                <el-button style="float: right" type="primary" @click="editshow = false">收起</el-button>
              </el-col>
            </el-row>
          </div>
          <div>
            <!-- 填写基础信息 -->
            <el-form ref="awardform" :model="awardform" label-width="120px" style="width: 50%">
              <el-form-item label="ID" prop="id">
                <el-input v-model="awardform.id" style="width: 50%" readonly></el-input>
              </el-form-item>
              <el-form-item label="入库数量" prop="reality_instorage">
                <el-input-number v-model="awardform.reality_instorage" style="width: 50%"
                  controls-position="right"></el-input-number>
              </el-form-item>
              <el-form-item label="状态" prop="push_status">
                <el-select v-model="awardform.push_status" disabled placeholder="请选择">
                  <el-option label="未推送" :value="0"></el-option>
                  <el-option label="已推送" :value="1"></el-option>
                  <el-option label="已推送" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item></el-form-item>
            </el-form>
            <div style="text-align: center">
              <!-- <el-button style="margin-top: 12px" @click="resetForm('awardform')">重置</el-button> -->
              <el-button style="margin-top: 12px" @click="submitadd('awardform')" type="primary">提交</el-button>
            </div>
          </div>
        </el-card>
        <el-popover placement="right" width="400">
          录入人工确认数量：
          <el-input-number v-model="reality_instorage" controls-position="right" :min="0"
            :max="9999999"></el-input-number>
          <el-button type="primary" @click="workaddupdatecount(row)">确认
          </el-button>
          <el-button slot="reference" class="bottstycz" type="primary" size="mini">人工录入数量</el-button>
        </el-popover>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="5">
            <span style="font-weight: bold;"> 工单：</span>{{ row.orderno }}
          </el-col>
          <el-col :span="5">
            <span style="font-weight: bold;"> 批次：</span>{{ row.batchno }}
          </el-col>
          <el-col :span="5">
            <span style="font-weight: bold;"> 产品编码：</span>{{ row.product_code }}
          </el-col>
          <el-col :span="8">
            <span style="font-weight: bold;"> 产品名称：</span>{{ row.product_name }}
          </el-col>
        </el-row>

        <el-divider></el-divider>
        <el-table show-summary :data="tableData" style="width: 100%" max-height="300" highlight-current-row>
          <af-table-column fixed prop="id" label="ID" width="150">
          </af-table-column>
          <af-table-column prop="reality_instorage" label="入库数量">
          </af-table-column>
          <af-table-column prop="push_status" label="状态"> </af-table-column>

          <af-table-column prop="push_time" label="推送时间"> </af-table-column>
          <af-table-column prop="update_time" label="修改时间">
          </af-table-column>
          <af-table-column prop="create_time" label="录入时间">
          </af-table-column>
          <el-table-column fixed="right" label="操作" min-width="250">
            <template slot-scope="props">
              <el-button type="primary" @click="getoutbilldata(props.row)" class="bottstycz"
                v-if="props.row.push_status !== '已推送'">
                修改</el-button>
              <el-button class="bottstycz" type="danger" @click="deletedate(props.row)"
                v-if="props.row.push_status !== '已推送'">
                删除</el-button>
              <el-button type="primary" @click="pushorder(props.row)" class="bottstycz"
                v-if="props.row.push_status == '未推送'">
                手工推送</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </transition>
</template>
<script>
import {
  InstorageList,
  workaddupdatecount,
  delInstorage,
  pushproduce,
  eidtInstorage
} from "@/api/plant";
export default {
  props: {
    search: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      reality_instorage: 0,
      row: {},
      tableData: [],
      //基础数据
      show: false,
      editshow: false,
      awardform: {}
    };
  },
  mounted() { },
  methods: {
    pushorder(row) {
      this.$confirm("此操作将推送该明细信息到erp, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        modal: true,
        type: "warning"
      })
        .then(() => {
          pushproduce({
            id: row.id
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "推送成功!"
              });
              this.search();
              this.getTabledata();
            } else {
              this.$message({
                type: "woring",
                message: "推送失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 录入数量
    workaddupdatecount(row) {
      workaddupdatecount({
        workorder_senior_id: row.id,
        reality_instorage: this.reality_instorage
      }).then(response => {
        if (response.status_code == 200) {
          this.visible = false;
          this.$message({
            type: "success",
            message: "录入成功!"
          });
          this.getTabledata();
        }
      });
    },
    getTabledata() {
      // 列表获取
      this.listLoading = true;
      InstorageList({ workorder_senior_id: this.row.id }).then(response => {
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].push_time.indexOf("0001-01-01T00:00:00") == 0) {
            response.data[i].push_time = "";
          }
          if (
            response.data[i].update_time.indexOf("0001-01-01T00:00:00") == 0
          ) {
            response.data[i].update_time = "";
          }
          console.log(
            response.data[i].push_time.indexOf("0001-01-01T00:00:00")
          );
          switch (response.data[i].push_status) {
            case 0:
              response.data[i].push_status = "未推送";
              break;
            case 1:
              response.data[i].push_status = "已推送";
              break;
            default:
              response.data[i].push_status = "已推送";
              break;
          }
        }
        this.tableData = response.data;
        this.show = true;
        console.log(response.data);
      });
    },
    // 修改明细
    getoutbilldata(row) {
      this.awardform = Object.assign({}, row);
      this.editshow = true;
    },
    // 删除按钮事件
    deletedate(row) {
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delInstorage({
            id: row.id
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
              this.getTabledata();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          eidtInstorage({
            id: this.awardform.id,
            reality_instorage: this.awardform.reality_instorage
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!"
              });
              this.resetForm("awardform");
              this.search();
              this.getTabledata();
              this.editshow = false;
            } else {
              this.$message({
                type: "warning",
                message: "修改失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style></style>
